module.exports = __webpack_public_path__ + "static/media/رحلات مائية في لوسيرن.ef0cdb8b.jpeg";